export default __webpack_public_path__ + "static/media/user-shield-solid.f905b803.svg";